var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"travel"},_vm._l((_vm.dataset),function(item,idx){return _c('TimelineItem',{key:idx,attrs:{"title":item.title,"dotColor":item.color}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }